<div class="enroll-spinner-wrapper" *ngIf="isLoading">
  <mat-spinner></mat-spinner>
</div>
<div class="container header data-section-base data-section-2">
  <div>
    <h1 fxShow fxHide.lt-lg class="merchant-enrollment-header">{{ 'WELCOME_ENROLLMENT' | translate }}</h1>
    <p class="merchant-enrollment-subtitle">{{ 'WELCOME_ENROLLMENT_DETAILS' | translate }}</p>
  </div>
  <form [formGroup]="langForm" style="max-width:300px;">
    <rezolve-drop-down formControlName="lang"
                       [label]="'LANGUAGE' | translate"
                       [placeholder]="'SELECT_LANGUAGE' | translate"
                       [items]="languages"
                       [optionTemplate]="languageOptionItems">
    </rezolve-drop-down>
    <ng-template #languageOptionItems let-item> {{ item.key | translate }}</ng-template>
  </form>
</div>
<form [formGroup]="form">
  <mat-card class="enroll-form-container">

    <rezolve-divider>{{ 'MERCHANT' | translate | uppercase }}</rezolve-divider>
    <div class="data-section-base">
      <rezolve-basic-input required="true"
                           formControlName="merchantName"
                           [label]="'MERCHANT_NAME' | translate"
                           [maxLength]="40"
                           [placeholder]="'ENTER_MERCHANT_NAME' | translate"
                           [errorDescriptions]="{required : 'REQUIRED'| translate}">
      </rezolve-basic-input>
      <rezolve-basic-input formControlName="merchantRfc"
                           [label]="'RFC_LABEL' | translate"
                           [maxLength]="20"
                           [placeholder]="'RFC_PLACEHOLDER' | translate">
      </rezolve-basic-input>
      <rezolve-numeric-input required="true"
                             formControlName="merchantBankAccount"
                             [label]="'CEP_ISSUING_BANK_ACCOUNT' | translate"
                             [maxLength]="20"
                             [placeholder]="'CEP_ISSUING_BANK_ACCOUNT_HINT' | translate"
                             [errorDescriptions]="{required: 'REQUIRED' | translate }">
      </rezolve-numeric-input>
    </div>

    <rezolve-divider>{{ 'USER' | translate | uppercase }}</rezolve-divider>
    <div class="data-section-base">
      <rezolve-basic-input required="true"
                           formControlName="userFirstname"
                           [label]="'USER_FIRSTNAME' | translate"
                           [placeholder]="'USER_FIRSTNAME_PLACEHOLDER' | translate"
                           [errorDescriptions]="{ required: 'REQUIRED' | translate}">
      </rezolve-basic-input>
      <rezolve-basic-input required="true"
                           formControlName="userSurnameFirst"
                           [label]="'USER_SURNAME_FIRST' | translate"
                           [placeholder]="'USER_SURNAME_FIRST_PLACEHOLDER' | translate"
                           [errorDescriptions]="{ required: 'REQUIRED' | translate}">
      </rezolve-basic-input>
      <rezolve-basic-input required="true"
                           formControlName="userSurnameSecond"
                           [label]="'USER_SURNAME_SECOND' | translate"
                           [placeholder]="'USER_SURNAME_SECOND_PLACEHOLDER' | translate"
                           [errorDescriptions]="{ required: 'REQUIRED' | translate}">
      </rezolve-basic-input>
    </div>
    <div class="data-section-base data-section-1">
      <rezolve-email-input required="true"
                           formControlName="userEmail"
                           [label]="'EMAIL' | translate"
                           [maxLength]="39"
                           [placeholder]="'ENTER_EMAIL_HINT' | translate"
                           [errorDescriptions]="{required: 'REQUIRED' | translate}">
      </rezolve-email-input>
</div>
    <div>
      <rezolve-signature [height]="200" [width]="400" required (isSignatureEmpty)="handleIsEmptySignature($event)"
                         (onSave)="handleOnSaveSignature($event)"></rezolve-signature>
    </div>
    <!-- <div class="data-section">
      <rezolve-checkbox required formControlName="termsAndConditions"
        [errorMessage]="'REQUIRED' | translate" (checkedChanged)="handleAgreement()">
        <span>
          {{'DECLARATION' | translate }}
        </span>
      </rezolve-checkbox>
      <span>
        <a target="_blank" class="link" (click)="openTandCPopUp()"> {{ 'TERMS_AND_CONDITIONS' | translate}} *</a>
      </span>
    </div> -->
  </mat-card>
</form>
<mat-dialog-actions fxLayoutAlign="end">
  <rezolve-primary-button [disabled]="form.invalid || !isSigned" classList="medium" (handleClick)="onSubmit()">
    {{ 'ENROLL' | translate }}
  </rezolve-primary-button>
</mat-dialog-actions>
